import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { planTimelineEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-timeline/entrypoint.tsx';

export const planTimelineRouteEntry = createPageEntryPoint({
	main: planTimelineEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
